import { FormControl, SxProps, Theme, ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";
import { CSSProperties } from "react";
import { StringOrNumber } from "../../../helpers/StringOrNumber";

export interface ICsmFormSegmentedRadioButtonListProps<T, U extends StringOrNumber> {
    value: U | null,
    list: T[],
    labelGetter: (e: T) => string | React.ReactNode,
    valueGetter: (e: T) => U,
    onChange: (e: U | null) => void,
    fontSize?: number,
    sx?: SxProps<Theme>,
    style?: CSSProperties,
    itemStyle?: CSSProperties | ((item: T, selected: boolean) => CSSProperties),
    disabled?: boolean,
}

function CsmFormSegmentedRadioButtonList<T, U extends StringOrNumber>(props: ICsmFormSegmentedRadioButtonListProps<T, U>) {
    const { value, list, labelGetter, valueGetter, onChange, fontSize, sx, disabled, style, itemStyle } = props;
    
    const fontSizeToUse = fontSize ?? 14;
    const strings = (list.select(labelGetter));
    strings.push('');

    function getInnerStyle(item: T, isSelected: boolean): CSSProperties | undefined {
        if (!itemStyle) return undefined;

        if (typeof itemStyle !== "function") return itemStyle;

        return itemStyle(item, isSelected);
    }

    return (
        <FormControl fullWidth style={{ marginTop: 0, ...style }}>
            <ToggleButtonGroup
                sx={sx}
                size="small"
                value={value}
                disabled={disabled}
                exclusive
                onChange={(e, v) => onChange(v)}
                aria-label="text alignment"
            >
                {list.map((item, index) => {
                    return (
                        <ToggleButton style={{ textTransform: "none", ...getInnerStyle(item, valueGetter(item) === value) }} value={valueGetter(item)} key={index}>
                            <Typography fontSize={fontSizeToUse}>{labelGetter(item)}</Typography>
                        </ToggleButton>
                    );
                })}
            </ToggleButtonGroup>
        </FormControl>
    );
}

export default CsmFormSegmentedRadioButtonList;